import React, { Component } from 'react';
import { RelevantIcon, setCookie } from '../oro-module/commonFunctions';
import { MdOpenInNew } from "react-icons/md";
import Table from 'reactstrap/lib/Table';






const FollowupListRecord = ({ main, sub, current }) => {
  let { color, size, weight, desc, value, url, payload, message } = main;

  const KPIValue = ({ value, style }) => {
    if (value.indexOf('icon-') != -1) {
      return <RelevantIcon icon={value.split('-')[1]} />;
    }
    else {
      return value;
    }
  }

  let sendData;
  let identi = Math.round(Math.random() * 10000000000);
  let gotourl = `/${url}`;
  if (payload) {
    gotourl = `/${url}/${identi}`;
    sendData = {};
    for (var key in payload) {
      if (payload[key].type == 'fixed') {
        sendData[key] = payload[key].value;
      }
    }
  }

  const handleLink = ({ url, identi, sendData }) => {
    setCookie(identi, JSON.stringify({ set: sendData }));
    window.open(url, "_blank");
  }

  const setMessage = (message) => {
    // current.props.liftGlobalState
  }

  const removeMessage = (message) => { }

  return (
    <div className="row"
    // style={{ marginLeft: -5, marginRight: -10, backgroundColor: main.color ? main.color : "" }}
    >
      {!url &&
        <div className="col-sm-7 sub-title" style={{ fontSize: 14 }}>{desc}</div>
      }

      {url &&
        <div className="col-sm-7 sub-title url-kpi hand"><span onClick={() => handleLink({ url: gotourl, sendData, identi })}>{desc}
          {/* <MdOpenInNew />  */}
        </span></div>
      }

      <div className="col-sm-5 action hand right" onMouseEnter={() => setMessage(message)} onMouseLeave={() => removeMessage(message)} style={{ fontSize: size ? size : 14, color: color ? color : "black" }}>
        <KPIValue style={{}} value={value} />
      </div>
      <div className="col-sm-12"><hr style={{ margin: 0 }}></hr></div>
    </div>
  );
}

const HTMLTableRow = ({ row, size = "small" }) => {

  return (
    <tr>
      {
        row.map((col, idx) =>
          <td key={idx} style={{ padding: size == 'small' ? 0 : "3" }}>{col}</td>
        )
      }
    </tr>
  )
}


class KPITable extends Component {
  componentDidMount() {
    // Load the data from the websocket connection

  }

  render() {
    let { values } = this.props.component;
    return (
      <div
        className={`form-group nopadding ${this.props.component.widths.parent}`}
      >
        <Table striped size="sm">
          <thead style={{ fontSize: "15px" }}>
            {values[0].map((col, idx) =>
              <th key={idx}>{col}</th>
            )}
          </thead>
          <tbody>
            {
              values.map((row, idx) => {
                if (idx > 0) {
                  return (
                    <HTMLTableRow key={idx} row={row} />
                  )
                }
              })
            }
          </tbody>
        </Table>
      </div>
    );
  }
}

export default KPITable;